import React, { useCallback, useContext, useEffect, useMemo } from 'react';
import { useLogger, useSelector } from '~Hooks';
import { getExpressMenus_allAppliedMenus_menu_menuEntries as MenuEntry } from '~Components/MenuManager/__queries__';

// @ts-expect-error
const Context = React.createContext<Record<string, MenuEntry>>(null);

export const EntryFinderProvider: React.FunctionComponent = ({ children }) => {
  const mountLogger = useLogger('mount');
  useEffect(() => {
    mountLogger.info('Mounted: EntryFinderProvider');
    return () => {
      mountLogger.info('Unmounted: EntryFinderProvider');
    };
  }, []);

  const menu = useSelector((state) => state.POSMenu);

  const map = useMemo(() => {
    if (!menu) {
      return {};
    }

    return menu.menuEntries.reduce((obj, entry) => {
      obj[entry.item.id] = entry;
      return obj;
    }, {} as Record<string, MenuEntry>);
  }, [menu]);

  return <Context.Provider value={map}>{children}</Context.Provider>;
};

export const useEntryFinder = () => {
  const finder = useContext(Context);
  return useCallback(
    (itemId: string) => {
      if (finder === null) {
        throw new Error('Missing Entry Finder Provider in context');
      }
      return finder[itemId];
    },
    [finder],
  );
};
